import React from 'react';
import { Heart, CreditCard, Church, Mail as MailIcon, ArrowRight } from 'lucide-react';
import { IMAGES, CHURCH } from '../mock/mock';
import Reveal from '../components/Reveal';

const Give = () => {
  const ways = [
    { icon: CreditCard, title: 'Give Online', text: 'Using our safe, secure online giving platform, you can feel confident about your gift. Click below to get started.', cta: 'https://forms.ministryforms.net/embed.aspx?formId=d4580db0-24b4-41c3-a190-f35067b12656&custom-templates=' },
    { icon: Church, title: 'Give on Sunday', text: 'During service, feel free to place your offering in our giving baskets as they are passed.' },
    { icon: MailIcon, title: 'Give by Mail', text: `${CHURCH.fullName}\n${CHURCH.poBox}\n${CHURCH.poCity}` },
  ];

  return (
    <div>
      <section className="relative h-[52vh] min-h-[420px] flex items-center justify-center overflow-hidden">
        <img src={IMAGES.givingHands} alt="Give" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0b2027]/80 via-[#0b2027]/60 to-[#0b2027]/85" />
        <div className="relative text-center px-6">
          <Reveal>
            <p className="text-[#c9a24b] uppercase tracking-[0.36em] text-xs mb-5">Live Generously</p>
            <h1 className="font-serif-display italic text-white text-5xl md:text-7xl">Give</h1>
          </Reveal>
        </div>
      </section>

      {/* WHY WE GIVE */}
      <section className="bg-[#f6f2ea] py-24 md:py-28">
        <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
          <Reveal>
            <Heart className="h-10 w-10 text-[#c9a24b] mx-auto mb-8" />
            <p className="text-[#3a4d54] text-lg leading-relaxed mb-6">
              Thank you for your partnership in ministry with us. We’re so grateful for the financial gifts given to allow us to continue the work of accomplishing God’s mission and vision for our church.
            </p>
            <p className="text-[#3a4d54] text-lg leading-relaxed">
              We give because God has so generously given to us. We believe in the principle of the tithe (Malachi 3). As we obediently give, we trust that He will provide for our needs and bring abundant blessing into our lives.
            </p>
          </Reveal>
        </div>
      </section>

      {/* WAYS TO GIVE */}
      <section className="bg-[#0f2e38] py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <Reveal className="text-center mb-16">
            <p className="text-[#c9a24b] uppercase tracking-[0.34em] text-xs mb-4">How to Partner</p>
            <h2 className="font-serif-display text-white text-4xl md:text-5xl">Ways to Give</h2>
          </Reveal>
          <div className="grid md:grid-cols-3 gap-8">
            {ways.map((w, i) => (
              <Reveal key={w.title} delay={i * 120} className="bg-white/5 border border-white/10 p-10 hover:border-[#c9a24b]/50 transition-colors duration-500">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-full border border-[#c9a24b]/50 mb-6">
                  <w.icon className="h-6 w-6 text-[#c9a24b]" />
                </div>
                <h3 className="font-serif-display text-white text-2xl mb-4">{w.title}</h3>
                <p className="text-white/70 leading-relaxed whitespace-pre-line">{w.text}</p>
                {w.cta && (
                  <a
                    href={w.cta}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-shine mt-7 inline-flex items-center gap-3 bg-[#c9a24b] text-[#0b2027] hover:bg-[#d8b566] px-7 py-3.5 uppercase tracking-[0.2em] text-xs font-700 transition-colors duration-300"
                  >
                    Donate Now <ArrowRight className="h-4 w-4" />
                  </a>
                )}
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Give;
